import { createContext } from 'react';
import { IMainContext } from './MainContext.types';

export const MainContext = createContext<IMainContext>({
    width: 0,
    isDesktop: true,
    isTablet: false,
    isMobile: false
});
